module.exports = __webpack_public_path__ + "img/Patrick Talley Resume 2021-2.ca06b12d.png";